export function logError(...args) {
  console.error(...args);
  /*try {
    console.re.error(...args);
    console.re.trace();
  } catch (err) {}*/
}
